import {MEETINGMINUTES} from "../../../services";
import {FileController} from "../../Boilerplate/FileController";

const docKey = ['match', 'params', 'id'];
const subDocKey = ['match', 'params', 'meetingMinutesId'];
const indexType = 'meetingminutes';
const topLevelName = 'Meeting Minutes';

export const MeetingMinuteFiles = FileController(MEETINGMINUTES, indexType, docKey, subDocKey, topLevelName);



// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinuteFiles.js